import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { RadioLabel, Input, Check } from "./styles/radio-button-styles";

interface IRadioButtonProps {
  field: unknown;
  form: unknown;
  value: string;
  label: string;
  disabled?: boolean;
}

const TextField: FunctionComponent<IRadioButtonProps> = ({
  field,
  ...props
}) => {
  const { value, label, disabled } = props;

  return (
    <RadioLabel htmlFor={value} disabled={disabled}>
      <Input {...field} {...props} id={label} value={value} />
      {label}
      <Check disabled={disabled} />
    </RadioLabel>
  );
};

TextField.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  field: PropTypes.shape({}),
};

TextField.defaultProps = {
  disabled: null,
  field: null,
};

export default TextField;
